import {
  IPlatformMethodologiesResponse,
  IPlatformMethodologyPayload,
  IPlatformMethodologyResponse
} from 'types/platformResources';
import request from './index';

export const getPlatformMethodologies = () =>
  request<IPlatformMethodologiesResponse>({
    options: { url: '/platform/resources/methodologies', method: 'get' }
  });

export const getPlatformMethodology = (id: number) =>
  request<IPlatformMethodologyResponse>({
    options: { url: `/platform/resources/methodologies/${id}`, method: 'get' }
  });

export const createPlatformMethodology = (data: IPlatformMethodologyPayload) =>
  request<IPlatformMethodologyResponse>({
    options: { url: '/platform/resources/methodologies', method: 'post', data }
  });

export const editPlatformMethodology = (id: number, data: IPlatformMethodologyPayload) =>
  request<IPlatformMethodologyResponse>({
    options: { url: `/platform/resources/methodologies/${id}`, method: 'patch', data }
  });

export const deletePlatformMethodology = (id: number) =>
  request<Record<string, never>>({
    options: { url: `/platform/resources/methodologies/${id}`, method: 'delete' }
  });
